import { authAxios } from "src/libs/axios/authAxios";
import { ISessionCheckReq } from "./types/user.type";
import { IUserInfo } from "./types/common.type";

export const sessionCheck = async (req: ISessionCheckReq): Promise<any> => {
  const response = await authAxios.get(`/wapi/cloud/user/sessionCheck`);

  return response.data;
};
interface updUserInfo {
  userPwd?: string;
  newUserPwd?: string;
}
// UserInfo데이터 중 하나만 받아옴
export const update = async (
  req: Partial<IUserInfo | updUserInfo>
): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/user/update`, req);

  return response.data;
};
export const list = async (): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/user/list`);

  return response.data;
};
export const listExcel = async (): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/user/list/excel`);

  return response.data;
};
